module.exports = {
  common: {
    zhanghu: '账户信息',
    dengjibenren: '登记本人确认文件',
    biangengmima: '变更密码',
    xiadanjilu: '下单记录',
  },
  shopList: {
    phone: '手 机',
    jiu: '酒',
    jiadian: '家 电',
    search: '搜索',
    color: '选择颜色'
  }
}
